export default __webpack_public_path__ + "static/media/icon-snooze-notifications.07161db4.svg";